<template>
  <div class="hmt-audio" v-if="getMusic">
    <button @click="togglePlay()">
      <FontAwesomeIcon :icon="isMuted ? 'volume-mute' : 'volume-up'" />
    </button>
    <audio loop autoplay ref="audio">
      <source :src="getMusic" type="audio/mpeg">
    </audio>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  const STORAGE_KEY = 'music_muted';

  export default {
    name: 'HMTAudio',
    data () {
      return {
        isMuted: false
      }
    },
    computed: {
      ...mapGetters('tour', ['getMusic']),
      ...mapGetters('ui', ['getRunVideo'])
    },
    methods: {
      setMuted () {
        this.isMuted = true;
        this.$refs.audio.volume = 0;
        localStorage.setItem(STORAGE_KEY , '1');
      },
      setUnmuted () {
        this.isMuted = false;
        this.$refs.audio.volume = 0.2;
        localStorage.setItem(STORAGE_KEY , '0');
      },
      togglePlay () {
        if (this.$refs.audio.paused) {
          this.$refs.audio.play();
          this.setUnmuted();
          return;
        }

        if (this.$refs.audio.volume > 0) {
          this.setMuted();
        } else {
          this.setUnmuted();
        }
      }
    },
    mounted () {
      if (!this.getMusic) {
        return;
      }

      this.$refs.audio.oncanplaythrough = () => {
        if (this.$refs.audio.paused) {
          this.setMuted();
          return;
        }

        if (localStorage.getItem(STORAGE_KEY) === '1') {
          this.setMuted();
        } else {
          this.setUnmuted();
        }
      };
    },
    watch: {
      getRunVideo () {
        if (this.getRunVideo && this.getMusic) {
          this.setMuted();
        }
      }
    }
  };
</script>

<style lang="scss">
	.hmt-audio {
		width: 32px;
		height: 32px;
		border-radius: 50%;
		overflow: hidden;
		transition: box-shadow .2s ease-out;

		&:hover {
			box-shadow: 0 0 5px 6px rgba(0,0,0,.1);
		}

		button {
			position: relative;
			z-index: 1;
			display: flex;
			justify-content: center;
			align-items: center;
			width: 100%;
			height: 100%;
			background: none;
			border: none;
			border-radius: 50%;
			outline: none;
			cursor: pointer;
		}

		audio {
			display: none;
		}
	}
</style>
